export const AssetType = {
  Pictogram: 'pictogram',
  Illustration: 'illustration',
  Icon: 'icon'
};
//# sourceMappingURL=constants.js.map